import React from 'react';

import organograma from '../../assets/organograma.png';

function Administracao() {
  return (
    <>
      <h1>Administração</h1>
      <p>A Cooperativa Cocrafi é administrada e fiscalizada na seguinte estrutura organizacional:
      </p>
      <img src={organograma} alt="Organograma" height="600px" />
    </>
  )
}

export default Administracao;